import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getGetConfigQueryOptions, useGetConfigSuspense } from '@/api/generated/endpoints';
import { RouteErrorFallback } from '@/components/route-error-fallback';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { CreateRunForm } from '@/features/runs/components/create-run-form';

export const Route = createFileRoute('/_authenticated/runs/new')({
	loader: ({ context: { queryClient } }) => {
		void queryClient.ensureQueryData(getGetConfigQueryOptions());
	},
	errorComponent: (props) => <RouteErrorFallback {...props} fallbackMessageKey='error_save_run' />,
	component: NewRunRoute,
});

function NewRunRoute() {
	const { t } = useTranslation();
	const navigate = useNavigate({ from: '/runs/new' });
	const { data: config } = useGetConfigSuspense();

	return (
		<Card>
			<CardHeader className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
				<div>
					<CardTitle>{t('runs_new_title')}</CardTitle>
					<CardDescription>{t('runs_new_description')}</CardDescription>
				</div>

				<Button asChild variant='outline'>
					<Link to='/runs'>
						<ArrowLeft className='size-4' />
						{t('runs_back_to_list')}
					</Link>
				</Button>
			</CardHeader>

			<CardContent>
				<CreateRunForm
					defaultInitialParticipant={config.defaultInitialParticipant}
					defaultInvitees={config.defaultInvitees}
					onSuccess={() => navigate({ to: '/runs' })}
				/>
			</CardContent>
		</Card>
	);
}
